import { ReactNode } from "react";
import { GlobalStateProvider } from "../../states/global-state/global.state";

/**
 * You can add all state providers here that need to be available in a global scope.
 * Improves readability for the index.tsx file and allows capsuled changes to the provided states.
 */
const WithStates = ({ children }: { children: ReactNode }) => {
  return <GlobalStateProvider>{children}</GlobalStateProvider>;
};

export default WithStates;
